/*
 * Argivit Focus landing section.
 * Switches the page between the two real products (syrup / capsules):
 * media, copy, prices and the highlighted buy card all follow one selection.
 */
(function () {
  function initSection(root) {
    if (root.dataset.motInitialized === 'true') return;
    root.dataset.motInitialized = 'true';
    root.classList.add('mot-js');

    var defaultType = root.getAttribute('data-mot-default-product') === 'capsules' ? 'capsules' : 'syrup';

    function applyAttributeValue(element, type, attribute) {
      var value = element.getAttribute('data-' + type);
      if (value === null) return;
      if (attribute) {
        element.setAttribute(attribute, value);
      } else {
        element.textContent = value;
      }
    }

    function toggleGroup(selector, attributeName, type) {
      root.querySelectorAll(selector).forEach(function (element) {
        var isActive = element.getAttribute(attributeName) === type;
        element.classList.toggle('is-active', isActive);
        if (element.hasAttribute('aria-selected')) {
          element.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      });
    }

    function setProduct(type) {
      var selectedType = type === 'capsules' ? 'capsules' : 'syrup';

      toggleGroup('[data-mot-switch]', 'data-mot-switch', selectedType);
      toggleGroup('[data-mot-tab]', 'data-mot-tab', selectedType);
      toggleGroup('[data-mot-panel]', 'data-mot-panel', selectedType);
      toggleGroup('[data-mot-nav-product]', 'data-mot-nav-product', selectedType);
      toggleGroup('[data-mot-hero-product]', 'data-mot-hero-product', selectedType);
      toggleGroup('[data-mot-price-product]', 'data-mot-price-product', selectedType);
      toggleGroup('[data-mot-buy-card]', 'data-mot-buy-card', selectedType);

      root.querySelectorAll('[data-mot-swap-text]').forEach(function (element) {
        applyAttributeValue(element, selectedType);
      });

      root.querySelectorAll('[data-mot-swap-href]').forEach(function (element) {
        applyAttributeValue(element, selectedType, 'href');
      });

      root.querySelectorAll('[data-mot-swap-compare]').forEach(function (element) {
        var value = element.getAttribute('data-' + selectedType);
        element.textContent = value || '';
        // A product without a compare-at price must not leave an empty strike-through.
        element.hidden = !value;
      });

      root.setAttribute('data-mot-selected', selectedType);
    }

    root.querySelectorAll('[data-mot-switch], [data-mot-tab], [data-mot-nav-product]').forEach(function (control) {
      control.addEventListener('click', function () {
        setProduct(
          control.getAttribute('data-mot-switch') ||
            control.getAttribute('data-mot-tab') ||
            control.getAttribute('data-mot-nav-product')
        );
      });
    });

    // Buttons that both jump to the order block and preselect a product there.
    root.querySelectorAll('[data-mot-select-product]').forEach(function (control) {
      control.addEventListener('click', function () {
        setProduct(control.getAttribute('data-mot-select-product'));
      });
    });

    root.querySelectorAll('[data-mot-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.mot-faq-item');
        var wasOpen = item.classList.contains('is-open');

        root.querySelectorAll('.mot-faq-item').forEach(function (faqItem) {
          faqItem.classList.remove('is-open');
          var faqButton = faqItem.querySelector('[data-mot-faq-button]');
          if (faqButton) faqButton.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    root.querySelectorAll('[data-mot-qty]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      if (!input) return;

      wrapper.querySelectorAll('[data-mot-qty-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.getAttribute('data-mot-qty-step'), 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // The mobile bar only matters once the hero's own buy block has scrolled away.
    var mobileBar = root.querySelector('.mot-mobile-sticky');
    var heroBuy = root.querySelector('.mot-hero-buy');
    if (mobileBar && heroBuy && 'IntersectionObserver' in window) {
      var barObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            mobileBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      barObserver.observe(heroBuy);
    } else if (mobileBar) {
      mobileBar.classList.add('is-visible');
    }

    var revealItems = root.querySelectorAll('[data-mot-reveal]');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    setProduct(defaultType);
  }

  function initAll() {
    document.querySelectorAll('[data-mot-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-run when the section is re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mot-root]').forEach(initSection);
  });
})();
